import { render, staticRenderFns } from "./ClosuresSearch.vue?vue&type=template&id=6c6da76e&"
import script from "./ClosuresSearch.vue?vue&type=script&lang=ts&"
export * from "./ClosuresSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports